var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmithvilleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228.174,
    height: 49.576,
    viewBox: "0 0 228.174 49.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_CMYK",
    "data-name": "Logo CMYK",
    transform: "translate(114.087 24.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058",
    transform: "translate(-114.087 -24.788)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3505",
    fill: "#ffd468",
    d: "M20.9 102.979a16.6 16.6 0 0 0 6.079 6.013 16.471 16.471 0 0 1 6.013-6.046 16.438 16.438 0 0 1-6.079-6.046 16.6 16.6 0 0 0-6.013 6.079",
    "data-name": "Path 3505",
    transform: "translate(-20.9 -78.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3506",
    fill: "#ffc528",
    d: "M39.3 92.255a16.438 16.438 0 0 0 6.079 6.013 16.438 16.438 0 0 1 8.235-2.255A16.438 16.438 0 0 1 47.568 90a16.438 16.438 0 0 0-8.268 2.255",
    "data-name": "Path 3506",
    transform: "translate(-33.287 -73.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3507",
    fill: "#f6982a",
    d: "M39.5 121.379a16.438 16.438 0 0 0 8.268 2.19 16.438 16.438 0 0 1 6.013-6.079 16.438 16.438 0 0 1-8.268-2.19 16.438 16.438 0 0 0-6.013 6.046",
    "data-name": "Path 3507",
    transform: "translate(-33.421 -90.496)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3508",
    fill: "#f5900b",
    d: "M57.9 110.655a16.438 16.438 0 0 0 8.268 2.19 16.6 16.6 0 0 1 8.268-2.255 16.6 16.6 0 0 1-8.268-2.19 16.438 16.438 0 0 0-8.235 2.255",
    "data-name": "Path 3508",
    transform: "translate(-45.808 -85.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    fill: "#e25916",
    d: "M64.8 123.433a16.438 16.438 0 0 0 8.235-2.255 16.6 16.6 0 0 1 6.013-6.079 16.6 16.6 0 0 1-8.235 2.255 16.438 16.438 0 0 0-6.013 6.079",
    "data-name": "Path 3509",
    transform: "translate(-50.453 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3510",
    fill: "#e05417",
    d: "M83.2 117.355a16.6 16.6 0 0 0 8.268-2.255 16.6 16.6 0 0 0-8.268 2.255",
    "data-name": "Path 3510",
    transform: "translate(-62.84 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3511",
    fill: "#cf231a",
    d: "M90 121.179a16.6 16.6 0 0 0 6.013-6.079A16.6 16.6 0 0 0 90 121.179",
    "data-name": "Path 3511",
    transform: "translate(-67.418 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3512",
    fill: "#e9b203",
    d: "M64.6 90a16.438 16.438 0 0 0 6.079 6.013 16.6 16.6 0 0 1 8.268 2.19 16.6 16.6 0 0 1-6.079-6.013A16.438 16.438 0 0 0 64.6 90",
    "data-name": "Path 3512",
    transform: "translate(-50.319 -73.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3513",
    fill: "#db8315",
    d: "M83.2 108.4a16.6 16.6 0 0 0 8.268 2.19 16.6 16.6 0 0 0-8.268-2.19",
    "data-name": "Path 3513",
    transform: "translate(-62.84 -85.851)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3514",
    fill: "#69862c",
    d: "M89.9 96.7a16.6 16.6 0 0 0 6.079 6.013A16.6 16.6 0 0 0 89.9 96.7",
    "data-name": "Path 3514",
    transform: "translate(-67.351 -77.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3515",
    fill: "#e76779",
    d: "M58 161.255a16.6 16.6 0 0 0 2.255 8.235 16.6 16.6 0 0 0 8.268-2.255A16.438 16.438 0 0 1 66.268 159 16.438 16.438 0 0 1 58 161.255",
    "data-name": "Path 3515",
    transform: "translate(-45.876 -119.914)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3516",
    fill: "#dd3b38",
    d: "M60.189 135.955A16.438 16.438 0 0 0 58 144.223a16.438 16.438 0 0 0 8.268-2.255 16.438 16.438 0 0 1 2.19-8.268 16.438 16.438 0 0 1-8.235 2.255",
    "data-name": "Path 3516",
    transform: "translate(-45.875 -102.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3517",
    fill: "#d3291b",
    d: "M70.713 117.355a16.438 16.438 0 0 0-6.013 6.079 16.438 16.438 0 0 0 8.235-2.255 16.6 16.6 0 0 1 6.013-6.079 16.6 16.6 0 0 1-8.235 2.255",
    "data-name": "Path 3517",
    transform: "translate(-50.386 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3518",
    fill: "#cf231a",
    d: "M83.1 117.355a16.6 16.6 0 0 0 8.268-2.255 16.6 16.6 0 0 0-8.268 2.255",
    "data-name": "Path 3518",
    transform: "translate(-62.773 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3519",
    fill: "#bd294c",
    d: "M89.313 140.4a16.438 16.438 0 0 1-6.013 6.079 16.438 16.438 0 0 0 2.255 8.268 16.438 16.438 0 0 0 6.013-6.079 16.438 16.438 0 0 1-2.255-8.235",
    "data-name": "Path 3519",
    transform: "translate(-62.907 -107.393)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3520",
    fill: "#b21326",
    d: "M91.5 115.1a16.6 16.6 0 0 1-6.013 6.079 16.438 16.438 0 0 0-2.19 8.268 16.438 16.438 0 0 0 6.013-6.079 16.6 16.6 0 0 1 2.19-8.268",
    "data-name": "Path 3520",
    transform: "translate(-62.907 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3521",
    fill: "#ae101b",
    d: "M96.013 115.1A16.6 16.6 0 0 0 90 121.179a16.6 16.6 0 0 0 6.013-6.079",
    "data-name": "Path 3521",
    transform: "translate(-67.418 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3522",
    fill: "#7a1537",
    d: "M103.89 115.033a16.6 16.6 0 0 1-2.19 8.268 16.438 16.438 0 0 0 2.255 8.235 16.438 16.438 0 0 0 2.19-8.268A16.6 16.6 0 0 1 103.89 115",
    "data-name": "Path 3522",
    transform: "translate(-75.294 -90.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3523",
    fill: "#720a1c",
    d: "M103.89 115.1a16.6 16.6 0 0 0-2.19 8.268 16.6 16.6 0 0 0 2.19-8.268",
    "data-name": "Path 3523",
    transform: "translate(-75.294 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3524",
    fill: "#470e2a",
    d: "M108.4 115.1a16.6 16.6 0 0 0 2.255 8.268 16.6 16.6 0 0 0-2.255-8.268",
    "data-name": "Path 3524",
    transform: "translate(-79.805 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3525",
    fill: "#76bd86",
    d: "M57.8 47.668a16.438 16.438 0 0 1 8.268 2.222 16.438 16.438 0 0 1 2.222-8.268 16.6 16.6 0 0 0-8.268-2.222 16.6 16.6 0 0 0-2.222 8.268",
    "data-name": "Path 3525",
    transform: "translate(-45.741 -39.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3526",
    fill: "#55a273",
    d: "M83.1 54.468a16.438 16.438 0 0 1 6.046 6.046 16.438 16.438 0 0 1 2.222-8.235 16.438 16.438 0 0 0-6.046-6.079 16.438 16.438 0 0 0-2.222 8.268",
    "data-name": "Path 3526",
    transform: "translate(-62.773 -43.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3527",
    fill: "#2c7e64",
    d: "M101.6 73a16.6 16.6 0 0 1 2.222 8.268 16.6 16.6 0 0 1 2.222-8.235 16.438 16.438 0 0 0-2.222-8.235 16.438 16.438 0 0 0-2.222 8.235",
    "data-name": "Path 3527",
    transform: "translate(-75.227 -56.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3528",
    fill: "#18484f",
    d: "M108.4 98.268A16.6 16.6 0 0 0 110.622 90a16.6 16.6 0 0 0-2.222 8.268",
    "data-name": "Path 3528",
    transform: "translate(-79.805 -73.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3529",
    fill: "#6eaa37",
    d: "M57.8 64.733a16.438 16.438 0 0 0 2.222 8.235 16.438 16.438 0 0 1 8.268 2.222 16.438 16.438 0 0 1-2.222-8.268A16.438 16.438 0 0 0 57.8 64.7",
    "data-name": "Path 3529",
    transform: "translate(-45.741 -56.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3530",
    fill: "#6d9e2f",
    d: "M64.6 90a16.438 16.438 0 0 0 6.046 6.046 16.6 16.6 0 0 1 8.268 2.222 16.6 16.6 0 0 1-6.046-6.046A16.438 16.438 0 0 0 64.6 90",
    "data-name": "Path 3530",
    transform: "translate(-50.319 -73.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3531",
    fill: "#69862c",
    d: "M83.1 108.5a16.6 16.6 0 0 0 8.268 2.222A16.6 16.6 0 0 0 83.1 108.5",
    "data-name": "Path 3531",
    transform: "translate(-62.773 -85.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3532",
    fill: "#529332",
    d: "M83.1 71.5a16.438 16.438 0 0 0 2.222 8.268 16.6 16.6 0 0 1 6.046 6.046 16.6 16.6 0 0 1-2.222-8.268A16.438 16.438 0 0 0 83.1 71.5",
    "data-name": "Path 3532",
    transform: "translate(-62.773 -61.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3533",
    fill: "#528b31",
    d: "M89.9 96.8a16.6 16.6 0 0 0 6.046 6.046A16.6 16.6 0 0 0 89.9 96.8",
    "data-name": "Path 3533",
    transform: "translate(-67.351 -78.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3534",
    fill: "#2f712f",
    d: "M101.6 90a16.6 16.6 0 0 0 2.222 8.268A16.6 16.6 0 0 0 101.6 90",
    "data-name": "Path 3534",
    transform: "translate(-75.227 -73.464)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3535",
    fill: "#fff",
    d: "M53.811 76.345c-.425-4.314 9.347-12.941 15.817-17.582a16.862 16.862 0 0 0-1.405-1.863 82.161 82.161 0 0 0-12.582 11.046l-.2.2c-2.484 2.909-4.216 5.915-3.987 8.4a4.15 4.15 0 0 0 1.471 2.941c1.765 1.438 4.543 1.144 7.516.817 4.9-.523 7.255-.458 7.713 2.484.719 4.739-8.791 11.863-13.693 15a14.51 14.51 0 0 0 .915 2.157 71.147 71.147 0 0 0 7.424-5.397c5.588-4.706 8.17-8.791 7.647-12.124-.85-5.458-6.275-4.869-10.262-4.445-2.353.261-4.771.523-5.784-.327a1.889 1.889 0 0 1-.621-1.373",
    "data-name": "Path 3535",
    transform: "translate(-41.458 -51.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3536",
    fill: "#b50014",
    d: "M140.084 98.714c6.34 0 10.752-3.268 10.752-9.085v-.1c0-5.1-3.366-7.255-9.314-8.791-5.065-1.307-6.34-1.928-6.34-3.856v-.1c0-1.438 1.307-2.549 3.758-2.549a13.748 13.748 0 0 1 7.615 2.876l3.366-4.869a16.961 16.961 0 0 0-10.883-3.726c-5.98 0-10.262 3.529-10.262 8.824v.1c0 5.817 3.824 7.451 9.706 8.954 4.9 1.242 5.915 2.092 5.915 3.726v.1c0 1.732-1.6 2.778-4.216 2.778-3.366 0-6.111-1.373-8.758-3.562l-3.823 4.574a18.66 18.66 0 0 0 12.451 4.706m13.464-.425h6.373V85.772c0-3.007 1.471-4.575 3.856-4.575s3.726 1.536 3.726 4.575v12.517h6.373V85.772c0-3.007 1.471-4.575 3.856-4.575s3.726 1.536 3.726 4.575v12.517h6.375V83.681c0-5.392-2.843-8.268-7.582-8.268a9.24 9.24 0 0 0-7.386 3.562 6.748 6.748 0 0 0-6.34-3.562 8.542 8.542 0 0 0-6.634 3.595v-3.17h-6.307Zm38.563 0h6.373V75.837h-6.34Zm19.281.392a9.379 9.379 0 0 0 5.033-1.307v-5.131a6.471 6.471 0 0 1-3.137.784c-1.438 0-2.059-.719-2.059-2.19V81.3h5.294v-5.463h-5.262v-5.751h-6.373v5.752h-2.68V81.3h2.68v10.649c0 5.2 2.647 6.732 6.536 6.732m8.758-.392h6.373V85.772c0-3.007 1.536-4.575 3.987-4.575s3.856 1.536 3.856 4.575v12.517h6.373V83.746c0-5.163-2.81-8.333-7.615-8.333-3.235 0-5.1 1.732-6.569 3.595V67.7h-6.405Zm30.425.163h5.784l8.824-22.615h-6.6l-5.065 15.033-5.033-15.033h-6.732Zm17.092-.163h6.373V75.837H267.7Zm11.079 0h6.373V67.7h-6.34Zm10.85 0h6.373V67.7h-6.34Zm20.654.49a11.3 11.3 0 0 0 9.183-4.183l-3.66-3.235a7.341 7.341 0 0 1-5.458 2.288 5.2 5.2 0 0 1-5.49-4.412h15.621c.033-.588.1-1.176.1-1.667 0-6.373-3.431-12.19-10.948-12.19-6.536 0-11.111 5.294-11.111 11.7v.1c0 6.863 5 11.6 11.732 11.6m-5.49-13.5c.49-2.876 2.222-4.771 4.869-4.771s4.346 1.928 4.739 4.771Z",
    "data-name": "Path 3536",
    transform: "translate(-92.73 -58.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3537",
    fill: "#1a1818",
    d: "M711.207 90.445v-.392h.294c.163 0 .229.065.229.2 0 .131-.1.2-.229.2Zm-.458.817h.458v-.49h.2l.327.49h.49l-.392-.556a.49.49 0 0 0 .327-.49.49.49 0 0 0-.131-.359.719.719 0 0 0-.523-.163h-.752Zm.654.588a1.307 1.307 0 0 1-1.307-1.34 1.34 1.34 0 1 1 2.647 0 1.34 1.34 0 0 1-1.34 1.34m0 .163a1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 0-3.007 0 1.5 1.5 0 0 0 1.5 1.5",
    "data-name": "Path 3537",
    transform: "translate(-484.733 -72.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3538",
    fill: "#b50014",
    d: "M327.262 72.024a3.562 3.562 0 1 0-3.562-3.562 3.562 3.562 0 0 0 3.562 3.562",
    "data-name": "Path 3538",
    transform: "translate(-224.744 -56.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3539",
    fill: "#b50014",
    d: "M558.456 72.024a3.33 3.33 0 0 0 3.268-3.562 3.562 3.562 0 0 0-7.124 0 3.843 3.843 0 0 0 3.889 3.562",
    "data-name": "Path 3539",
    transform: "translate(-380.185 -56.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3540",
    fill: "#b50014",
    d: "M140.084 98.714c6.34 0 10.752-3.268 10.752-9.085v-.1c0-5.1-3.366-7.255-9.314-8.791-5.065-1.307-6.34-1.928-6.34-3.856v-.1c0-1.438 1.307-2.549 3.758-2.549a13.748 13.748 0 0 1 7.615 2.876l3.366-4.869a16.961 16.961 0 0 0-10.883-3.726c-5.98 0-10.262 3.529-10.262 8.824v.1c0 5.817 3.824 7.451 9.706 8.954 4.9 1.242 5.915 2.092 5.915 3.726v.1c0 1.732-1.6 2.778-4.216 2.778-3.366 0-6.111-1.373-8.758-3.562l-3.823 4.574a18.66 18.66 0 0 0 12.451 4.706m13.464-.425h6.373V85.772c0-3.007 1.471-4.575 3.856-4.575s3.726 1.536 3.726 4.575v12.517h6.373V85.772c0-3.007 1.471-4.575 3.856-4.575s3.726 1.536 3.726 4.575v12.517h6.375V83.681c0-5.392-2.843-8.268-7.582-8.268a9.24 9.24 0 0 0-7.386 3.562 6.748 6.748 0 0 0-6.34-3.562 8.542 8.542 0 0 0-6.634 3.595v-3.17h-6.307Zm38.563 0h6.373V75.837h-6.34Zm19.281.392a9.379 9.379 0 0 0 5.033-1.307v-5.131a6.471 6.471 0 0 1-3.137.784c-1.438 0-2.059-.719-2.059-2.19V81.3h5.294v-5.463h-5.262v-5.751h-6.373v5.752h-2.68V81.3h2.68v10.649c0 5.2 2.647 6.732 6.536 6.732m8.758-.392h6.373V85.772c0-3.007 1.536-4.575 3.987-4.575s3.856 1.536 3.856 4.575v12.517h6.373V83.746c0-5.163-2.81-8.333-7.615-8.333-3.235 0-5.1 1.732-6.569 3.595V67.7h-6.405Zm30.425.163h5.784l8.824-22.615h-6.6l-5.065 15.033-5.033-15.033h-6.732Zm17.092-.163h6.373V75.837H267.7Zm11.079 0h6.373V67.7h-6.34Zm10.85 0h6.373V67.7h-6.34Zm20.654.49a11.3 11.3 0 0 0 9.183-4.183l-3.66-3.235a7.341 7.341 0 0 1-5.458 2.288 5.2 5.2 0 0 1-5.49-4.412h15.621c.033-.588.1-1.176.1-1.667 0-6.373-3.431-12.19-10.948-12.19-6.536 0-11.111 5.294-11.111 11.7v.1c0 6.863 5 11.6 11.732 11.6m-5.49-13.5c.49-2.876 2.222-4.771 4.869-4.771s4.346 1.928 4.739 4.771Z",
    "data-name": "Path 3540",
    transform: "translate(-92.73 -58.451)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmithvilleLogo);
export default __webpack_public_path__ + "static/media/smithville-Logo.09f109a4971aa1404b881f192170cda8.svg";
export { ForwardRef as ReactComponent };